import React, { Component } from 'react';
import { ProductConsumer } from "../context";
import styled from "styled-components";

export default class DressingOnPizza extends Component {
    
    render(){
        return(
            <ProductConsumer>
			{(value) => {
                const { handleInputChangeDressing,dressing_pizza,submit} = value;
                const valuesToRemove = [4,6]
                // const extra = dressing_pizza.filter(item => !valuesToRemove.includes(item))
                console.log(dressing_pizza);
				return (
					<DressingOnPizzaWrapper className="">
					
                <div className="container">
                    <div className="col">
                        <br /><br />
                        <h3>Dressing</h3><br />
                        
                        <div className="form-row">
                            <div className="form-group col-md-6">
                               
                               
                                <div className="form-check form-check-inline">
                                   <input className="form-check-input" type="checkbox" name="Dressing" id="inlineCheckboxh1" value="5" onChange={handleInputChangeDressing} />
                                   <label className="form-check-label" htmlFor="inlineCheckboxh1">Dressing på pizza</label>
                               </div>
                             
            
                            </div>
                        </div>
 
                    </div>
                </div>
            
					</DressingOnPizzaWrapper>
				);
			}}
		</ProductConsumer>
           
        )  
    }
}
const DressingOnPizzaWrapper = styled.div`
.ekstra{
    width:200px;
}
`;